import WordMonthDate from "Components/DateChanged/WordMonthDate/WordMonthDate";
import MoneyMask from "Components/MoneyMask/MoneyMask";

function isDateString(value) {
    const regex = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2})?$/;

    if (!regex.test(value)) {
        return false;
    }

    const [year, month, day] = value.substring(0, 10).split("-");

    const date = new Date(Number(year), Number(month) - 1, Number(day));

    return (
        date.getFullYear() === Number(year) &&
        date.getMonth() + 1 === Number(month) &&
        date.getDate() === Number(day)
    );
}

function formatAttribute(value, mask, isDetail, minimumFractionDigits) {
    if ((value === null) && !isDetail) {
        return '- - -'
    }

    if (value === null) {
        return value
    }

    if (!isDateString(value)) {
        if (mask === 'money') {
            return MoneyMask.validateMoneyMask(value);
        }

        if (minimumFractionDigits) {
            return validateMaskFraction(value, minimumFractionDigits)
        }

        if (value == '0') {
            return '0,00'
        }

        return value.toString();
    }
    return WordMonthDate.dateFormat(value)
}


function validateMaskFraction(value, minimumFractionDigits) {
    if (/[a-zA-Z]/.test(value)) {
        return value;
    }

    if (value === 0) return value;

    const formattedValue = value.toLocaleString('pt-BR', {
        minimumFractionDigits: minimumFractionDigits,
    }).replace(',', '.');

    return formattedValue;
}

export default { isDateString, formatAttribute };
